export const environment = {
  production: true,
  graphQLEndpoint: 'https://api-v2-gcp.mybhutan.com/api/graphql',
  server: 'https://api-v2-gcp.mybhutan.com/'
};



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/environments/environment.ts